/* kaelon-klaviyo-newsletter-consent-v1 */
(() => {
  if (window.__kaelonKlaviyoNewsletterBridge) return;
  window.__kaelonKlaviyoNewsletterBridge = true;
  const companyId = "T22GQC";
  const listId = "U5XMjh";
  const endpoint = `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`;

  function init() {
    document.querySelectorAll('form').forEach((form) => {
      const container = form.querySelector('[data-kaelon-klaviyo-source]');
      if (!container || form.dataset.kaelonKlaviyoBound === 'true') return;
      form.dataset.kaelonKlaviyoBound = 'true';
      form.addEventListener('submit', async (event) => {
        if (form.dataset.kaelonKlaviyoSubmitting === 'true') return;
        const consent = form.querySelector('[name="kaelon_email_marketing_consent"]');
        const emailInput = form.querySelector('input[name="contact[email]"]');
        if (!consent || !consent.checked) {
          event.preventDefault();
          if (consent) { consent.focus(); consent.reportValidity(); }
          return;
        }
        if (!emailInput || !emailInput.value || !emailInput.checkValidity()) return;
        event.preventDefault();
        const submit = form.querySelector('[type="submit"]');
        const error = form.querySelector('[data-kaelon-klaviyo-error]');
        if (error) error.hidden = true;
        if (submit) submit.disabled = true;
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: container.dataset.kaelonKlaviyoSource,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: emailInput.value.trim(),
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };
        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'accept': 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', 'revision': '2026-07-15' },
            body: JSON.stringify(payload)
          });
          if (response.status !== 202) throw new Error(`Klaviyo subscription failed (${response.status})`);
          form.dataset.kaelonKlaviyoSubmitting = 'true';
          HTMLFormElement.prototype.submit.call(form);
        } catch (err) {
          if (error) error.hidden = false;
          if (submit) submit.disabled = false;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
